// Preview popup header per-file actions: Send to Telegram, toggle Favorite, Download.
// All act on the CURRENTLY previewed file (read from state at click time) so they
// stay correct after a hover-switch or keyboard nav. Reuse the file-list row logic.

import { getPreviewState } from '../state.js';
import { sendFileToTelegram } from '../../tg-send.js';
import { favHas, favToggle, favAddTooltip, favRemoveTooltip } from '../../../../favorites/favorites-state.js';
import { encodeFilePath } from '../../../../../modules/files/file-list.utils.js';

// Reconstruct the row's file href + favorites identity path from the previewed
// file object (same rules as file-list.dom/render.js).
export function buildActionRefs(file) {
	const p = (file.p || file.path || '').replace(/^\//, '').replace(/\/+/, '/');
	const n = (file.n || file.name || '');
	const rel = `${p}${p ? '/' : ''}${n}`;
	const hasOnline = !!(file.o === 1 || file.online === 1);
	const isOT = !!(file.ot || file.ot_level || (typeof file.category === 'string' && file.category.toUpperCase() === 'OT'));
	let href;
	if (hasOnline) href = `/online/${encodeFilePath(rel)}`;
	else if (isOT) href = `/library/${encodeFilePath(rel)}?ot=1`;
	else href = `/library/${encodeFilePath(rel)}`;
	return { href, relPath: rel };
}

export function setupActionButtons(popupElement, newState) {
	const $favBtn = popupElement.find('.preview-popup__fav');
	const $tgBtn = popupElement.find('.preview-popup__tg');

	function currentRefs() {
		const st = getPreviewState();
		const f = st.currentPreviewFile ? st.currentPreviewFile.file : null;
		return f ? buildActionRefs(f) : null;
	}
	function syncFavBtn() {
		const refs = currentRefs();
		const on = refs ? favHas(refs.relPath) : false;
		$favBtn.find('i').attr('class', 'bi ' + (on ? 'bi-star-fill' : 'bi-star'));
		$favBtn.toggleClass('preview-popup__fav--on', on);
		$favBtn.attr('title', on ? favRemoveTooltip() : favAddTooltip());
	}
	syncFavBtn();

	$favBtn.off('click.previewFav').on('click.previewFav', function(e) {
		e.preventDefault();
		e.stopPropagation();
		const refs = currentRefs();
		if (!refs) return;
		favToggle(refs.href, refs.relPath);
		syncFavBtn();
	});
	$tgBtn.off('click.previewTg').on('click.previewTg', function(e) {
		e.preventDefault();
		e.stopPropagation();
		const refs = currentRefs();
		if (!refs) return;
		sendFileToTelegram($tgBtn.find('i'), refs.href);
	});

	// Download the CURRENT file — always via /library/ (attachment disposition),
	// never /online/ (which opens in the browser).
	const $dlBtn = popupElement.find('.preview-popup__download');
	$dlBtn.off('click.previewDl').on('click.previewDl', function(e) {
		e.preventDefault();
		e.stopPropagation();
		const st = getPreviewState();
		const f = st.currentPreviewFile ? st.currentPreviewFile.file : null;
		if (!f) return;
		const p = (f.p || f.path || '').replace(/^\//, '').replace(/\/+/, '/');
		const n = (f.n || f.name || '');
		const rel = `${p}${p ? '/' : ''}${n}`;
		const isOT = !!(f.ot || f.ot_level || (typeof f.category === 'string' && f.category.toUpperCase() === 'OT'));
		const href = `/library/${encodeFilePath(rel)}${isOT ? '?ot=1' : ''}`;
		const a = document.createElement('a');
		a.href = href;
		a.setAttribute('download', n || '');
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
	});
	// Re-sync the star on any favorites change AND on a document switch (hover / nav)
	$(document).off('favorites:changed.previewFav preview:switched.previewFav')
		.on('favorites:changed.previewFav preview:switched.previewFav', syncFavBtn);
}
